import { render, staticRenderFns } from "./FrontPaymentsModal.vue?vue&type=template&id=127f00e4"
import script from "./FrontPaymentsModal.vue?vue&type=script&lang=js"
export * from "./FrontPaymentsModal.vue?vue&type=script&lang=js"
import style0 from "./FrontPaymentsModal.vue?vue&type=style&index=0&id=127f00e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports